import { render, staticRenderFns } from "./TablaContratosCliente.vue?vue&type=template&id=92dbe612"
import script from "./TablaContratosCliente.vue?vue&type=script&lang=js"
export * from "./TablaContratosCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports